import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner } from "react-bootstrap";

import Card from "../../components/Card";
import MasterService from "../../services/master/MasterService";
import DataTable from "react-data-table-component";

const MetodeLab = () => {
    const columns = [
        {
            name: 'ID Metode',
            cell: row => row['idMetodeP15'] 
        },
        {
            name: 'Metode Uji',
            cell: row => row['metodeUji'] 
        }
    ]

    let masterService = useMemo(() => new MasterService(), [])

    const [listMetodeLab, setlistMetodeLab] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getlistMetodeLab = useCallback(async (page, size) => {
        setLoading(true)
        try {
            const response = await masterService.listMetodeLab(null, page, size)
            setlistMetodeLab(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            console.log(error)
            setlistMetodeLab([])
        }
        setLoading(false)
    }, [masterService])

    useEffect(() => {
        getlistMetodeLab(0, 10)
    }, [getlistMetodeLab])

    const handleChangePage = (page) => {
        getlistMetodeLab(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await masterService.listMetodeLab(null, page - 1, size)
        setlistMetodeLab(_res.data.data)
        setSize(size)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Master Metode Lab</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                        <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listMetodeLab}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );

}

export default MetodeLab